import { useIntl } from 'react-intl'
import * as Feed from 'layouts/feed'
import * as Options from 'layouts/feed/options'
import * as Events from '@avcan/prismic/clients/events'
import * as Context from 'layouts/feed/context'
import * as Params from '@avcan/utils/params'
import { DropdownFromOptions as Dropdown } from 'components/controls'
import { Control } from 'components/form'
import { EVENT } from '@avcan/prismic/types'

export async function getStaticProps({ locale }) {
    const [data, tags] = await Promise.all([Events.getList(undefined, locale), Events.getTags()])

    return {
        props: {
            tags,
            data,
        },
    }
}

export default function EventList({ tags, data }) {
    const intl = useIntl()
    const title = intl.formatMessage({
        defaultMessage: 'Events',
    })
    const form = <Form tags={tags} />

    return (
        <Context.Provider paramsSchema={ParamsSchema} data={data} type={EVENT}>
            <Feed.Layout title={title} form={form} />
        </Context.Provider>
    )
}

// Utils
function Form({ tags }) {
    const { params, onParamsChange } = Context.useContext()
    const monthOptions = Options.useMonthsOptions()
    const yearOptions = Options.useYearOptions()
    const timeLineOptions = Options.useTimelineOptions()
    function handlePastChange(past) {
        onParamsChange({
            past,
            page: 1,
        })
    }
    function handleTagsChange(tags) {
        onParamsChange({
            tags,
            page: 1,
        })
    }

    return (
        <Feed.ControlSet>
            <Control>
                <Dropdown
                    value={params.past}
                    onChange={handlePastChange}
                    options={timeLineOptions}
                    placeholder={timeLineOptions.get(params.past)}
                />
            </Control>
            <Control>
                <Options.TagsDropdown
                    values={tags}
                    value={params.tags}
                    onChange={handleTagsChange}
                />
            </Control>
        </Feed.ControlSet>
    )
}

// Constants
const ParamsSchema = {
    page: Params.PageParam,
    past: Params.BooleanParam,
    tags: Params.SetParam,
}
